module.exports = __webpack_public_path__ + "img/mystic-miners-3.25b657a9.webp";